// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1F8N5","row":"ProcedureTreatmentSummary_row__3nNXc"};